<template>
    <content-view>
        <div class="addInfo-main">
            <a-form :form="form">
                <a-form-item label="资讯标题" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入资讯标题（15字以内）" v-decorator="['title',{rules: [{required: true, message: '请输入资讯标题（15字以内）',max: 15}]}]" :disabled="isDisable"></a-input>
                </a-form-item>
                <a-form-item label="展示范围" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select @change="onChangeCity" mode="multiple" placeholder="请选择" v-decorator="['showCity',{rules: [{required: true, message: '请选择展示范围',}]}]" :disabled="isDisable">
                        <a-select-option :disabled="item !== '全国' && disabledCity" :value="item" v-for="item in cityList" :key="item">{{item}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="展示图" :labelCol="labelCol" :wrapperCol="wrapperCol" :required="true">
                    <image-uploader ref="uploader" :disabled="isDisable" :value="imgUrl" @uploaded="uploaded"></image-uploader>
                </a-form-item>
                <a-form-item label="资讯内容" :labelCol="labelCol" :wrapperCol="wrapperCol" :required="true">
                    <rich-text ref="rich" :list="contentList" v-if="!isDisable"></rich-text>
                    <rich-text-viewer :list="contentList" v-else></rich-text-viewer>
                </a-form-item>
                <a-form-item class="text-center">
                    <a-button @click="backStep">返回</a-button>
                    <a-button class="mr8" type="primary" @click="handleSubmit" v-if="!isDisable">保存</a-button>
                </a-form-item>
            </a-form>
        </div>
    </content-view>
</template>

<script type="text/javascript">
    import ImageUploader from '@/components/common/image-uploader.component'
    import richText from '@/components/modules/rich-text.component'
    import richTextViewer from '@/components/modules/rich-text-viewer.component'
    export default {
        name: "addNews",
        components: {
            ImageUploader,
            richText,
            richTextViewer
        },
        props: {},
        data() {
            return { 
                labelCol: {span: 8},
                wrapperCol: {span: 10},
                isDisable: false,
                imgUrl: "",
                cityList: ['全国'],
                contentList: [],
                disabledCity: false
            };
        },
        computed: {},
        methods: {
            getCityList() {
                this.$api.totalPlatform.cityList().then(res => {
                    this.cityList = this.cityList.concat(res);
                });
            },
            
            // 获取详情
            detailNews() {
                this.$api.operation
                .detailNews({
                    params: {id: this.id}
                })
                .then(res => {
                    res.content = JSON.parse(res.content);
                    this.imgUrl = res.imgUrl;
                    this.contentList = [];
                    res.content.map(item => {
                        this.contentList.push(item);
                    })
                    let valuesForm = {
                        title: res.title,
                        showCity: res.showCity.split(','),
                    }
                    this.$nextTick(() => {
                        this.form.setFieldsValue(
                            valuesForm
                        )
                    })
                });
            },

            // 提交保存
            handleSubmit() {
                this.form.validateFields((err, values) => {
                    if (!err) {
                        this.getContentList();
                        values.content = JSON.stringify(this.contentList);
                        values.imgUrl = this.imgUrl;
                        values.showCity = values.showCity.toString();
                        if(!this.imgUrl) {
                            this.$message.error('请选择展示图');
                            return false;
                        }
                        if(this.contentList.length == 0) {
                            this.$message.error('请编写咨询内容');
                            return false;
                        }
                        if(this.$route.name == 'addNews') { // 新增
                            this.addNews(values);
                        }else { // 编辑
                            this.updateNews(values);
                        }
                    }
                });
            },
            // 新增
            addNews(values) {
                this.$api.operation
                .addNews({
                    body: values
                })
                .then(res => {
                    this.$message.success('操作成功')
                    this.$router.go(-1)
                });
            },

            // 编辑
            updateNews(values) {
                this.$api.operation
                .updateNews({
                    body: Object.assign(values, {id: this.id})
                })
                .then(res => {
                    this.$message.success('操作成功')
                    this.$router.go(-1)
                });
            },

            onChangeCity(city) {
                const cityList = this.$utils.deepClone(this.cityList).splice(1)
                if(city.indexOf('全国') !== -1) {
                    this.$nextTick(() => {
                        this.form.setFieldsValue({['showCity']: cityList})
                    })
                }
            },
            getContentList () {
                this.contentList = this.$utils.deepClone(this.$refs.rich.getData());
            },

            uploaded(val) {
                this.imgUrl = val;
            },
            backStep() {
                this.$router.go(-1);
            }
        },

        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        created() {},
        mounted() {
            this.getCityList();
            if(this.$route.name !== 'addNews') {
                this.id = this.$route.query.id;
                this.detailNews();
            }
            if(this.$route.name === 'detailNews') {
                this.isDisable = true;
            }
        }
    };
</script>
<style lang="scss">
    .addInfo-main {
        background-color: #fff;
        padding: 24px 32px;
        border-radius: 2px;
        .addInfo-form {
            .goAdd {
            color: $text-color-primary;
            text-decoration: underline;
            cursor: pointer;
            margin-left: 10px;
            }
            .ant-input-number,
            .ant-calendar-picker {
            width: 100%;
            }
            .avatar-uploader > .ant-upload {
            width: 230px;
            height: 128px;
            }
            .ant-upload-select-picture-card .ant-upload-text {
            margin-top: 8px;
            color: $text-color-black-65;
            }
        }
    }
</style>